var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input", {
    attrs: {
      value: _vm.value,
      label: _vm.label,
      fancy: _vm.fancy,
      "has-error": _vm.hasError,
    },
    on: {
      keydown: function ($event) {
        return _vm.onKeyDown($event)
      },
      paste: function ($event) {
        $event.preventDefault()
      },
      focus: function ($event) {
        return _vm.onFocus($event)
      },
      blur: function ($event) {
        return _vm.onBlur($event)
      },
      "selection-change": function ($event) {
        return _vm.onSelectionChange($event)
      },
    },
    nativeOn: {
      input: function ($event) {
        return _vm.onInput($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }